import { useMqttTopic } from '../mqtt.jsx'
import { fmtTime } from '../format.js'

export default function TopTenPage() {
  const qualifiers = useMqttTopic('qualifiers')
  const list = qualifiers?.qualifiers ?? []

  return (
    <div>
      <div className="section-head">
        <h2>Top Ten Qualifiers</h2>
        <p>Full field, best time from any Timed or Top Ten session, deduped by rider — highlighted rows currently qualify</p>
      </div>

      {list.length === 0 ? (
        <div className="empty-state">No qualifying times yet.</div>
      ) : (
        <div className="tt-grid">
          {list.map((q, i) => {
            const qualified = i < 10
            const rank1 = i === 0
            return (
              <div key={`${q.num}-${q.rider}`}>
                <div className={`tt-row ${qualified ? 'qualified' : ''} ${rank1 ? 'rank-1' : ''}`}>
                  <div className="tt-rank">{q.pos}</div>
                  <div className="tt-who">
                    <div className="name">
                      #{q.num} {q.rider}
                    </div>
                    <div className="machine">{q.className}</div>
                  </div>
                  <div className="tt-time mono">{fmtTime(q.best)}</div>
                </div>
                {i === 9 && list.length > 10 && <div className="tt-divider">Qualifying cutoff — top 10 advance to the Run-Off</div>}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
